import React from "react";
import { FilesUIConfig } from "./FilesUIConfig";

export const FilesUiContext: React.Context<FilesUIConfig>
    = React.createContext({});